/*
 * @Author: ezhizao 庄德政
 * @LastEditors: ezhizao 庄德政
 * @Description: 
 */
const RootPath = window.g.baseUrl
const apis = {
  /* 导航 */
  getNavigations: RootPath + 'plugin/websys/navigation/index',
  getNavigation: RootPath + 'plugin/websys/navigation/getForm',
  saveNavigation: RootPath + 'plugin/websys/navigation/save',
  delNavigations: RootPath + 'plugin/websys/navigation/delete',
}

export default apis
